module.exports = __webpack_public_path__ + "img/message-ques.1709e13f.png";